module.exports = __webpack_public_path__ + "bc54381fa7a911c812c28fec777186cf.svg";